module.exports = __webpack_public_path__ + "img/pic-hdxzd.514f14c0.jpg";